import { render, staticRenderFns } from "./SamePageLink.vue?vue&type=template&id=6d6b589c&lang=pug"
import script from "./SamePageLink.vue?vue&type=script&lang=ts"
export * from "./SamePageLink.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports